import api from './api';

export type StreetTurnGroupBy = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
export interface StreetTurnCountsRow {
  username: string;
  dispatcher: string;
  periods: Record<string, number>;
  total: number;
}
export interface StreetTurnCountsResponse {
  start: string;
  end: string;
  groupBy: StreetTurnGroupBy;
  criteria: string;
  periods: string[];
  rows: StreetTurnCountsRow[];
  periodTotals: Record<string, number>;
  grandTotal: number;
}

export async function getDispatcherStreetTurns(params: { start: string; end: string; groupby: StreetTurnGroupBy }): Promise<StreetTurnCountsResponse> {
  const response = await api.get<StreetTurnCountsResponse>('/reporting/dispatcher-street-turns', { params });
  return response.data;
}
